<template>
  <article class="previous__item">
    <h2 class="previous__caption">{{ category.categoryDescription }}</h2>
    <AppSlider
      :items="category.items"
      :extension="'jpg'"
      :sliderType="'oneSlideInRow'"
    />
  </article>
</template>

<script>
import AppSlider from '~/components/AppSlider.vue'

export default {
  props: {
    category: {
      type: Object,
      required: true
    }
  },
  components: {
    AppSlider
  }
}
</script>

<style lang="scss">
  .previous__caption {
    color: #282830;
  }
</style>


// WEBPACK FOOTER //
// components/PreviousContestItem.vue